export default [
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
          title: '车险人伤'
        },
        children:[
          {
            path: '/',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '车险人伤-控制台'
            },
          },
          {
            path: 'console',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '车险人伤-控制台'
            },
          },
          


        



        
          {
            path: '/roleLimits',//角色菜单管理
            name: 'roleLimits',
            component: () => import('@/views/main/base/roleLimits'),
            meta: {
              title: '车险人伤-角色菜单管理'
            },
          },
          {
            path: '/accountManagement',//账号管理
            name: 'accountManagement',
            component: () => import('@/views/main/base/accountManagement'),
            meta: {
              title: '车险人伤-账号管理'
            },
          },
          {
            path: '/menuManagement',//菜单管理
            name: 'menuManagement',
            component: () => import('@/views/main/base/menuManagement'),
            meta: {
              title: '车险人伤-菜单管理'
            },
          },
          {
            path: '/updatePassword',//编辑密码
            name: 'updatePassword',
            component: () => import('@/views/main/base/updatePassword'),
            meta: {
              title: '车险人伤-编辑密码'
            },
          },


          {
            path: '/organizationManage',//机构管理
            name: 'organizationManage',
            component: () => import('@/views/main/base/organizationManage'),
            meta: {
              title: '车险人伤-机构管理'
            },
          },
          {
            path: '/roleManage',//角色管理
            name: 'roleManage',
            component: () => import('@/views/main/base/roleManage'),
            meta: {
              title: '车险人伤-角色管理'
            },
          },
          {
            path: '/userManage',//人员管理
            name: 'userManage',
            component: () => import('@/views/main/base/userManage'),
            meta: {
              title: '车险人伤-人员管理'
            },
          },
          {
            path: '/department',//部门管理
            name: 'department',
            component: () => import('@/views/main/base/department'),
            meta: {
              title: '车险人伤-部门管理'
            },
          },
          

          {
            path: '/caseManageIndex1',//新案件
            name: 'caseManageIndex1',
            component: () => import('@/views/main/caseManage/index1'),
            meta: {
              title: '车险人伤-新案件'
            },
          },
          {
            path: '/caseManageIndex2',//待派工
            name: 'caseManageIndex2',
            component: () => import('@/views/main/caseManage/index2'),
            meta: {
              title: '车险人伤-待派工'
            },
          },
          {
            path: '/caseManageIndex3',//作业中
            name: 'caseManageIndex3',
            component: () => import('@/views/main/caseManage/index3'),
            meta: {
              title: '车险人伤-作业中'
            },
          },
          {
            path: '/caseManageIndex4',//案件审核
            name: 'caseManageIndex4',
            component: () => import('@/views/main/caseManage/index4'),
            meta: {
              title: '车险人伤-案件审核'
            },
          },
          {
            path: '/caseManageIndex5',//审核加派/改派申请
            name: 'caseManageIndex5',
            component: () => import('@/views/main/caseManage/index5'),
            meta: {
              title: '车险人伤-审核加派/改派申请'
            },
          },
          {
            path: '/caseManageAll',//全部案件
            name: 'caseManageAll',
            component: () => import('@/views/main/caseManage/all'),
            meta: {
              title: '车险人伤-全部案件'
            },
          },

          {
            path: '/caseManageDetail',//案件详情
            name: 'caseManageDetail',
            component: () => import('@/views/main/detail/detail'),
            meta: {
              title: '车险人伤-案件详情'
            },
          },
          {
            path: '/addWoundedInformation',//添加伤者信息
            name: 'addWoundedInformation',
            component: () => import('@/views/main/add/addWoundedInformation'),
            meta: {
              title: '车险人伤-案件详情'
            },
          },
          {
            path: '/editWoundedInformation',//编辑伤者信息
            name: 'editWoundedInformation',
            component: () => import('@/views/main/edit/editWoundedInformation'),
            meta: {
              title: '车险人伤-案件详情'
            },
          },
          
          

          
          {
            path: '/caseTaskManageIndex1',//新案件
            name: 'caseTaskManageIndex1',
            component: () => import('@/views/main/caseTaskManage/index1'),
            meta: {
              title: '车险人伤-新案件'
            },
          },
          {
            path: '/caseTaskManageIndex2',//人伤跟踪
            name: 'caseTaskManageIndex2',
            component: () => import('@/views/main/caseTaskManage/index2'),
            meta: {
              title: '车险人伤-人伤跟踪'
            },
          },
          {
            path: '/surveyNoCompleted',//指派查勘未提交
            name: 'surveyNoCompleted',
            component: () => import('@/views/main/caseTaskManage/surveyNoCompleted'),
            meta: {
              title: '车险人伤-指派查勘未提交'
            },
          },
          {
            path: '/surveyCompleted',//指派查勘完成
            name: 'surveyCompleted',
            component: () => import('@/views/main/caseTaskManage/surveyCompleted'),
            meta: {
              title: '车险人伤-指派查勘完成'
            },
          },
          {
            path: '/caseTaskManageIndex3',//查勘审核
            name: 'caseTaskManageIndex3',
            component: () => import('@/views/main/caseTaskManage/index3'),
            meta: {
              title: '车险人伤-查勘审核'
            },
          },
          {
            path: '/caseTaskManageIndex4',//方案审核
            name: 'caseTaskManageIndex4',
            component: () => import('@/views/main/caseTaskManage/index4'),
            meta: {
              title: '车险人伤-方案审核'
            },
          },
          {
            path: '/caseTaskManageIndex5',//总部退回
            name: 'caseTaskManageIndex5',
            component: () => import('@/views/main/caseTaskManage/index5'),
            meta: {
              title: '车险人伤-总部退回'
            },
          },
          {
            path: '/caseTaskManageIndex6',//加派/改派申请进度查询
            name: 'caseTaskManageIndex6',
            component: () => import('@/views/main/caseTaskManage/index6'),
            meta: {
              title: '车险人伤-加派/改派申请进度查询'
            },
          },

          {
            path: '/caseTaskManageAll',//全部案件
            name: 'caseTaskManageAll',
            component: () => import('@/views/main/caseTaskManage/all'),
            meta: {
              title: '车险人伤-全部案件'
            },
          },
          {
            path: '/caseTaskManageDetail',//案件详情
            name: 'caseTaskManageDetail',
            component: () => import('@/views/main/detail/taskDetail'),
            meta: {
              title: '车险人伤-案件详情'
            },
          },



          {
            path: '/surveyTaskManageIndex1',//查勘任务管理
            name: 'surveyTaskManageIndex1',
            component: () => import('@/views/main/surveyTaskManage/index1'),
            meta: {
              title: '车险人伤-查勘任务管理'
            },
          },
          {
            path: '/surveyTaskManageIndex2',//查勘任务管理
            name: 'surveyTaskManageIndex2',
            component: () => import('@/views/main/surveyTaskManage/index2'),
            meta: {
              title: '车险人伤-查勘任务管理'
            },
          },
          {
            path: '/surveyTaskManageIndex3',//查勘任务管理
            name: 'surveyTaskManageIndex3',
            component: () => import('@/views/main/surveyTaskManage/index3'),
            meta: {
              title: '车险人伤-查勘任务管理'
            },
          },
          {
            path: '/surveyTaskManageAll',//查勘任务管理
            name: 'surveyTaskManageAll',
            component: () => import('@/views/main/surveyTaskManage/all'),
            meta: {
              title: '车险人伤-查勘任务管理'
            },
          },
          
          {
            path: '/humanDetailCK',//查勘任务详情
            name: 'humanDetailCK',
            component: () => import('@/views/main/detail/humanDetailCK'),
            meta: {
              title: '车险人伤-查勘任务详情'
            },
          },

          
          {
            path: '/mediationTaskManageIndex1',//调解任务管理
            name: 'mediationTaskManageIndex1',
            component: () => import('@/views/main/mediationTaskManage/index1'),
            meta: {
              title: '车险人伤-调解任务管理'
            },
          },
          {
            path: '/mediationTaskManageIndex2',//调解任务管理
            name: 'mediationTaskManageIndex2',
            component: () => import('@/views/main/mediationTaskManage/index2'),
            meta: {
              title: '车险人伤-调解任务管理'
            },
          },
          {
            path: '/mediationTaskManageIndex3',//调解任务管理
            name: 'mediationTaskManageIndex3',
            component: () => import('@/views/main/mediationTaskManage/index3'),
            meta: {
              title: '车险人伤-调解任务管理'
            },
          },
          {
            path: '/mediationTaskManageIndex4',//调解任务管理
            name: 'mediationTaskManageIndex4',
            component: () => import('@/views/main/mediationTaskManage/index4'),
            meta: {
              title: '车险人伤-调解任务管理'
            },
          },
          {
            path: '/mediationTaskManageAll',//调解任务管理
            name: 'mediationTaskManageAll',
            component: () => import('@/views/main/mediationTaskManage/all'),
            meta: {
              title: '车险人伤-调解任务管理'
            },
          },
          
          {
            path: '/humanDetailCK',//查勘任务详情
            name: 'humanDetailCK',
            component: () => import('@/views/main/detail/humanDetailCK'),
            meta: {
              title: '车险人伤-查勘任务详情'
            },
          },
          {
            path: '/humanDetailTJ',//查勘任务详情
            name: 'humanDetailTJ',
            component: () => import('@/views/main/detail/humanDetailTJ'),
            meta: {
              title: '车险人伤-查勘任务详情'
            },
          },

          {
            path: '/audit',//查勘任务审核
            name: 'audit',
            component: () => import('@/views/main/audit/index'),
            meta: {
              title: '车险人伤-审核任务'
            },
          },
          {
            path: '/audit2',//调解任务详情
            name: 'audit2',
            component: () => import('@/views/main/audit/index2'),
            meta: {
              title: '车险人伤-审核任务'
            },
          },
          {
            path: '/dispatchingConfiguration',//派工机构设置
            name: 'dispatchingConfiguration',
            component: () => import('@/views/main/dispatchingConfiguration/index'),
            meta: {
              title: '车险人伤-派工机构设置'
            },
          },
        ]
    },

    {
      path: '/woundedInformationDetail',//编辑伤者信息
      name: 'woundedInformationDetail',
      component: () => import('@/views/main/detail/woundedInformationDetail'),
      meta: {
        title: '车险人伤-案件详情'
      },
    },

]